import "./ProjectTreeRowCommon.css";

import { useSelector } from "react-redux";

import { getUserPermissions } from "slices/auth";
import { getUserSettingsLsrStatus } from "slices/user_adv";

import ProjectTreeHandleValidator from "./ProjectTreeHandleValidator";
import CircleStatus from "./ProjectTreeRowCircleStatus";
import ProjectTreeRowComment from "./ProjectTreeRowComment";
import ProjectTreeRowName from "./ProjectTreeRowName";
import useTreeRow from "./useTreeRow";

const ProjectTreeRowCommon = ({ rowObj, callbacks }) => {
	const paddingLeft = 26;
	const { getStyle } = useTreeRow();
	const userPermissions = useSelector(getUserPermissions);
	const lsrStatusUsage = useSelector(getUserSettingsLsrStatus);

	return (
		<div className="project-tree-row" style={{ paddingLeft: paddingLeft, width: `calc(100% - ${paddingLeft}px)`, ...getStyle({ rowObj }) }}>
			{userPermissions?.is_expert && (
				<span className="auto-status">
					<CircleStatus rowObj={rowObj} />
				</span>
			)}
			{userPermissions?.is_expert &&
				rowObj.double_is_winner !== false &&
				lsrStatusUsage === true &&
				(rowObj.type === "kats" || rowObj.type === "vor") && <ProjectTreeHandleValidator rowObj={rowObj} />}
			<ProjectTreeRowName rowObj={rowObj} fontSize={13} callbacks={callbacks} />
			{rowObj?._has_comment && <ProjectTreeRowComment rowObj={rowObj} callbacks={callbacks} />}
		</div>
	);
};

export default ProjectTreeRowCommon;
